import React, { Component } from 'react';
import { connect } from 'react-redux';

// import { uploadTest } from '../redux/actions'

class Upload extends Component {

    uploadFile(){
        // this.props.uploadTest()
    }

    render() { 
        return ( 
            <div>
                <p>Upload</p>
                <button onClick={()=>this.uploadFile()}>Upload</button>
            </div>
         );
    }
}
 
export default connect()(Upload);